import { FinanceLabField } from "@/entities/FinanceLab/FinanceLab.model";
import { AccountLabel } from "@/entities/Labeling/Account.model";
import { MetricSource, MetricType } from "./Metrics.types";

export const METRIC_CONFIG = {
    [AccountLabel.ASSETS]: {
        label: "Total Assets",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.ASSETS,
    },
    [AccountLabel.CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS]: {
        label: "Cash & Equivalents",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.CURRENT_ASSETS_CASH_AND_CASH_EQUIVALENTS,
    },
    [AccountLabel.CURRENT_ASSETS_NET_INVENTORY]: {
        label: "Inventory",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.CURRENT_ASSETS_NET_INVENTORY,
    },
    [AccountLabel.CURRENT_ASSETS_NET_RECEIVABLES]: {
        label: "Accounts Receivable",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.CURRENT_ASSETS_NET_RECEIVABLES,
    },
    [AccountLabel.CURRENT_LIABILITIES_ACCOUNTS_PAYABLE]: {
        label: "Accounts Payable",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.CURRENT_LIABILITIES_ACCOUNTS_PAYABLE,
    },
    [AccountLabel.CURRENT_LIABILITIES_DEBT]: {
        label: "Current Debt Balance",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.CURRENT_LIABILITIES_DEBT,
    },
    [AccountLabel.EBITDA]: {
        label: "EBITDA",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.EBITDA,
    },
    [AccountLabel.EBITDA_MARGIN]: {
        label: "EBITDA Margin",
        type: MetricType.PERCENTAGE,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.EBITDA_MARGIN,
    },
    [AccountLabel.GROSS_MARGIN]: {
        label: "Gross Margin",
        type: MetricType.PERCENTAGE,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.GROSS_MARGIN,
    },
    [AccountLabel.LIABILITIES]: {
        label: "Total Liabilities",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.LIABILITIES,
    },
    [AccountLabel.NET_INCOME]: {
        label: "Net Income",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.NET_INCOME,
    },
    [AccountLabel.NET_INCOME_MARGIN]: {
        label: "Net Income Margin",
        type: MetricType.PERCENTAGE,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.NET_INCOME_MARGIN,
    },
    [AccountLabel.NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT]: {
        label: "Gross PP&E",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.NONCURRENT_ASSETS_PROPERTY_PLANT_AND_EQUIPMENT,
    },
    [AccountLabel.REVENUES]: {
        label: "Revenue",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: AccountLabel.REVENUES,
    },
    [FinanceLabField.ORGANIZATION_FINANCIAL_DATA_CASH]: {
        label: "Cash & Equivalents",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: FinanceLabField.ORGANIZATION_FINANCIAL_DATA_CASH,
    },
    [FinanceLabField.ORGANIZATION_FINANCIAL_DATA_EBITDA]: {
        label: "EBITDA",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: FinanceLabField.ORGANIZATION_FINANCIAL_DATA_EBITDA,
    },
    [FinanceLabField.ORGANIZATION_FINANCIAL_DATA_EBITDA_MARGIN_P]: {
        label: "EBITDA Margin",
        type: MetricType.PERCENTAGE,
        source: MetricSource.FINANCE_API,
        code: FinanceLabField.ORGANIZATION_FINANCIAL_DATA_EBITDA_MARGIN_P,
    },
    [FinanceLabField.ORGANIZATION_FINANCIAL_DATA_GROSS_MARGIN_P]: {
        label: "Gross Margin",
        type: MetricType.PERCENTAGE,
        source: MetricSource.FINANCE_API,
        code: FinanceLabField.ORGANIZATION_FINANCIAL_DATA_GROSS_MARGIN_P,
    },
    [FinanceLabField.ORGANIZATION_FINANCIAL_DATA_NET_INCOME]: {
        label: "Net Income",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: FinanceLabField.ORGANIZATION_FINANCIAL_DATA_NET_INCOME,
    },
    [FinanceLabField.ORGANIZATION_FINANCIAL_DATA_NET_INCOME_MARGIN_P]: {
        label: "Net Income Margin",
        type: MetricType.PERCENTAGE,
        source: MetricSource.FINANCE_API,
        code: FinanceLabField.ORGANIZATION_FINANCIAL_DATA_NET_INCOME_MARGIN_P,
    },
    [FinanceLabField.ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY]:
        {
            label: "Sales & Marketing Efficiency",
            type: MetricType.MULTIPLE,
            source: MetricSource.FINANCE_API,
            code: FinanceLabField.ORGANIZATION_FINANCIAL_DATA_SALES_AND_MARKETING_EFFICIENCY,
        },
    [FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS]: {
        label: "Total Assets",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_ASSETS,
    },
    [FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES]: {
        label: "Total Liabilities",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_LIABILITIES,
    },
    [FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE]: {
        label: "Revenue",
        type: MetricType.CURRENCY,
        source: MetricSource.FINANCE_API,
        code: FinanceLabField.ORGANIZATION_FINANCIAL_DATA_TOTAL_REVENUE,
    },
};
